import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';

export const userRoutes: Routes = [
    {
        path: 'users/audit-trails',
        loadComponent: () => import('./audit-trails/audit-trails.component').then((c) => c.AuditTrailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_VIEW_AUDIT_TRAIL'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'users',
        loadComponent: () => import('./view-users/view-users').then((c) => c.ViewUsers),
    },
    {
        path: 'users/:uuid/preview',
        loadComponent: () => import('./preview-user-details/preview-user-details.component').then((c) => c.PreviewUserDetailsComponent),
        canActivate: [ngxPermissionsGuard],
        data: {
            permissions: {
                only: ['ROLE_USER_ACCOUNTS_VIEW'],
                redirectTo: AUTH_REDIRECT_ROUTE,
            },
        },
    },
    {
        path: 'users/designations',
        loadComponent: () => import('./designations/designations.component').then((c) => c.DesignationsComponent),
    },
];

